// relatorio.js — junta os dados de progresso de cada criança para a Área dos Pais.
// Tudo vem do BACKEND, que confere que o perfil pertence à conta logada (o pai só
// vê os próprios filhos). Reaproveita as leituras já existentes de atividades.

import { GET, DELETE } from './api';
import { getMundos, carregarProgresso, carregarPerfilGamer } from './atividades';

// Notinhas do chat (base dos "momentos de atenção" e do clima emocional)
export const getNotinhas = async (profileId) => {
  try {
    const r = await GET(`/chat-notinhas?profile=${profileId}`, true);
    return r && Array.isArray(r.data) ? r.data : [];
  } catch (e) {
    return [];
  }
};

const getProgressoIdioma = async (profileId, personagem) => {
  try {
    return await GET(`/chat-progressos?profile=${profileId}&personagem=${personagem}`, true);
  } catch (e) {
    return null;
  }
};

// Monta o relatório completo de uma criança (perfil).
export const montarRelatorio = async (profile) => {
  const pid = profile.id;
  const [mundos, prog, gamer, lulu, nando, notinhas] = await Promise.all([
    getMundos(),
    carregarProgresso(pid, pid),
    carregarPerfilGamer(pid, pid),
    getProgressoIdioma(pid, 'lulu'),
    getProgressoIdioma(pid, 'nando'),
    getNotinhas(pid),
  ]);

  // Atividades
  const completos = mundos.filter((m) => [1, 2, 3].every((f) => (prog[`${m.slug}:${f}`] || 0) > 0)).length;
  const totalEstrelas = Object.values(prog).reduce((s, v) => s + (v || 0), 0);

  // Clima emocional + momentos de atenção
  const contagem = {};
  (notinhas || []).forEach((n) => {
    if (n.sentimento) contagem[n.sentimento] = (contagem[n.sentimento] || 0) + 1;
  });
  const sentimentos = Object.entries(contagem).sort((a, b) => b[1] - a[1]);
  const atencao = (notinhas || []).filter((n) => n.tema_grande);

  return {
    atividades: {
      completos,
      totalMundos: mundos.length,
      totalEstrelas,
      dias: gamer?.dias_seguidos || 0,
      figurinhas: (gamer?.figurinhas || []).length,
    },
    idiomas: { lulu, nando },
    momentos: { sentimentos, atencao, totalConversas: (notinhas || []).length },
  };
};

// ---- Memória do personagem (o que ele "lembra" daquela criança) ----
// O backend devolve só a CONTAGEM — o texto das conversas nunca sai de lá.
export const getMemoria = async (profileId) => {
  try {
    return await GET(`/memoria-crianca?profile=${profileId}`, true);
  } catch (e) {
    return null;
  }
};

// Apaga tudo o que o personagem lembra daquela criança. Quem manda é a família.
export const apagarMemoria = async (profileId) => {
  try {
    return await DELETE(`/memoria-crianca?profile=${profileId}`, true);
  } catch (e) {
    return null;
  }
};
